module.exports = __webpack_public_path__ + "img/accuffr_icas.30c9c5cb.png";